import React, { useState, useEffect } from "react";
import { Modal, TextInput, Button, Group } from "@mantine/core";
import classes from "./EditKpi.module.css";
import { RowDataKPIObjective } from "./types";

interface EditKPIModalProps {
  isOpen: boolean;
  onClose: () => void;
  onEditKPI: (editedKPIData: RowDataKPIObjective) => void;
  kpiData: RowDataKPIObjective;
}

const EditKPIModal: React.FC<EditKPIModalProps> = ({
  isOpen,
  onClose,
  onEditKPI,
  kpiData,
}) => {
  const [editedKPI, setEditedKPI] = useState<RowDataKPIObjective>(kpiData);

  // Update the state when transData changes
  useEffect(() => {
    setEditedKPI(kpiData);
  }, [kpiData]);

  const handleEdit = () => {
    // Perform validation or additional logic as needed
    onEditKPI(editedKPI);
    onClose();
  };

  return (
    <Modal
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          Edit KPI Objective
        </div>
      }
      opened={isOpen}
      onClose={onClose}
    >
      <div className={classes.editForm}>
        <TextInput
          label="Title"
          maxLength={255}
          value={editedKPI.title}
          onChange={(event) =>
            setEditedKPI({ ...editedKPI, title: event.currentTarget.value })
          }
        />

        <TextInput
          label="Description"
          maxLength={255}
          value={editedKPI.description}
          onChange={(event) =>
            setEditedKPI({
              ...editedKPI,
              description: event.currentTarget.value,
            })
          }
        />

        <Group className={classes.buttonBottom}>
          <Button onClick={() => onClose()} className={classes.buttonCancel}>
            Back
          </Button>
          <Button onClick={handleEdit} className={classes.buttonSaveChanges}>
            Save Changes
          </Button>
        </Group>
      </div>
    </Modal>
  );
};

export default EditKPIModal;
